/**
 * Type guard to validate that a string is an enum member. Pass the enum
 * as a type parameter to ensure Typescript narrows your variable to the enum.
 *
 * Example usage:
 * ```
 * if (isInEnum<ProcedureStatus>(someString, ProcedureStatus)) {
 *    // ✅ ProcedureStatus
 *    procedure.status = someString;
 * }
 * // ❌ Type 'string' is not assignable to type 'ProcedureStatus'. ts(2322)
 * procedure.status = someString;
 * ```
 */
const isInEnum = (value, enumToCheck) => {
  if (!Object.values(enumToCheck).includes(value)) {
    return false;
  }

  return true;
};
/**
 * Takes a string or enum member and converts it to the passed enum type.
 * Returns undefined if the string is not an enum member. Type param must be
 * passed.
 *
 * Usage:
 * ```
 * stringToEnum<MapSourceType>(waypoint.type, MapSourceType)
 * ```
 */

const stringToEnum = (value, enumToCheck) => {
  if (!isInEnum(value, enumToCheck)) return undefined;
  return value;
};

export { isInEnum, stringToEnum };
